import {Tag} from 'antd';

export function ExportStatusCMP({text}) {

    if (text === 'pending') {
        return <Tag color={`blue`}>در صف انتظار</Tag>
    } else if (text === 'processing') {
        return <Tag color={`yellow`}>در حال آماده سازی</Tag>
    } else if (text === 'completed') {
        return <Tag color={`green`}>کامل شده</Tag>
    } else if (text === 'failed') {
        return <Tag color={`red`}>ناموفق</Tag>
    } else if (text === 'cancelled') {
        return <Tag color={`default`}>لغو شده</Tag>
    } else if (text === 'rejected') {
        return <Tag color={`pink`}>رد شده</Tag>
    } else if (text === 'expired') {
        return <Tag color={`default`}>منقضی شده</Tag>
    } else if (text === 'unknown') {
        return <Tag color={`default`}>نامشخص</Tag>
    }
    return <Tag color={`gray`}>{'بدون وضعیت'}</Tag>
}

export function ExportTypeCMP({text}) {

    if (text === 'product-delivery-export') {
        return <div>لیست اقلام قابل تحویل</div>
    }

    return <Tag color={`gray`}>ناشناخته</Tag>
}
